/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

const axios = require('axios').default;
import firebase from '@/services/saleData';
import 'firebase/database';
import 'firebase/firestore';
//import router from '@/router';
import moment from "moment-timezone";
import _ from 'lodash';
export default {
  // addItem({ commit }, item) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/data-list/products/", {item: item})
  //       .then((response) => {
  //         commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  
  /*saveData ({state}) {
    const user = _.clone(state.user)
    const emailKey = user.email.toString().replace(/\./g, '||')
    if(user.edit && user.password === '') {
      delete user.password
    }
    if(user.company === undefined) {
      user.company = '--TEST--'
    }
    return new Promise(async (resolve, reject) => {
      if(user.avatar_path.substring(0,5) === 'https'){
        user.avatar_path = null
        user.edit = null
        firebase.database().ref(`/users/${emailKey}`).set(user).then(()=> {
          resolve(`${user.firstname} ${user.lastname}`)
        }).catch((error) => { reject(error) })
        
      }else{
        user.avatar_path = null
        await firebase.storage().ref().child(`users/${user.email}`).put(user.avatar).then(() => {
          user.avatar = `https://firebasestorage.googleapis.com/v0/b/oktallentdb.appspot.com/o/users%2F${user.email}?alt=media`;
        });
        firebase.database().ref(`/users/${emailKey}`).set(user).then(()=> {
          resolve(`${user.firstname} ${user.lastname}`)
        }).catch((error) => { reject(error) })
      }
    })
  },*/
  async createHistory ({rootState,commit},{userId,qty,type}) {
    firebase.firestore().collection("history").add({
      code:userId.code,
      userkey:userId.key,
      qty,
      status:'กำลังดำเนินการ',
      type,
      updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
      createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
      employee:rootState.AppActiveUser,
      employeeCreated:true,
    }).then(()=>{
      commit('SET_POPUP2',false);
    });
  },
  async updateStatus ({ state,rootState,commit },status) {
    const data = state.selected;
    const user = (await firebase.database().ref(`/users/${data.userkey}`).once('value')).val();
    if(user && data.key){
      if(status === 'ปรับยอด') {
        if(Number(user.credit)<Number(data.qty)){
          commit('SET_POPUP',false);
          await firebase.firestore().collection("history").doc(data.key).update({
            status:'โปรดตรวจสอบเครดิต',
            updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
            employee:rootState.AppActiveUser,
          });
          return {status:false,error:'โปรดตรวจสอบเครดิต'};
        }
      }
      firebase.firestore().collection("history").doc(data.key).update({
        bank:user.bank,
        account_no:user.account_no,
        status,
        updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
        employee:rootState.AppActiveUser,
      }).then(()=>{
        if(status === 'ปรับยอด') {
          axios({
            method: "get",
            url: "https://api.xxmac.co/qremovecredit/removecredit/"+data.key,
          });
        }else if(status === 'โอนเงิน'){
          axios({
            method: "get",
            url: "https://api.xxmac.co/qwithdraw/withdraw/"+data.key,
          });
        }else if(status === 'โอนเงินscb'){
          axios({
            method: "get",
            url: "https://api.xxmac.co/autoscb/withdraw/"+data.key,
          });
        }else if(status === 'โอนเงินkbank'){
          axios({
            method: "get",
            url: "https://api.xxmac.co/qwithdraw/withdrawkbank/"+data.key,
          });
        }
      });
      commit('SET_POPUP',false);
    }
    // if(data.key){
    //   firebase.firestore().collection("history").doc(data.key).update({
    //     status,
    //     updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
    //     employee:rootState.AppActiveUser,
    //   }).then(()=>{
    //     if(status === 'ปรับยอด') {
    //       axios({
    //         method: "post",
    //         url: "https://api.ufaeasy888.com/deletecredit",
    //         data: {
    //           historyId: data.key,
    //           userId: data.userId,
    //           qty: data.qty
    //         }
    //       });
    //     }else if(status === 'โอนเงิน'){
    //       axios({
    //         method: "get",
    //         url: "https://api.ufaeasy888.com/audio2/transcode2/"+data.key,
    //       });
    //     }
    //   });
    // }
    commit('SET_POPUP',false);
  },
  async fetchDeposit ({ commit,state }) {
    const _users = (await firebase.database().ref(`/users`).once('value')).val();
    const users = [];
    for(const x in _users){
      users[_users[x].userId] = _users[x];
    }
    let deposits = (state.deposit.length>0)?state.deposit:[];
    firebase.firestore().collection("history").where("type", "==", "ฝาก").orderBy('createdate','desc')
    .onSnapshot((snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            const deposit = change.doc.data();
            if(users[deposit.userId]){
              const user = users[deposit.userId];
              deposit.key = change.doc.id;
              deposit.linename = user.linename;
              deposit.firstname = user.firstname;
              deposit.lastname = user.lastname;
              deposit.bank = user.bank;
              deposit.account_no = user.account_no;
              deposit.code = user.code;
              deposit.pictureUrl = user.pictureUrl;
              deposits.push(deposit);
            }
          }
          if (change.type === "modified") {
              const value = change.doc.data();
              const keyUser = _.findKey(deposits, function(o) { return o.key === change.doc.id; });
              if(keyUser){
                const deposit =  deposits[keyUser];
                deposit.qty = value.qty;
                deposit.status = value.status;
                deposit.updatetime = moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss");
                deposits.splice(keyUser, 1);
                deposit.key = change.doc.id;
                deposits.splice(keyUser, 0, deposit);
              }
          }
        });
        if(deposits.length > 0){
          deposits = _.orderBy(deposits, ['createdate'],['desc']);
          commit('SET_DEPOSIT', deposits);
        }
    });
    //commit('SET_USERS', []);
  },
  async fetchDeposit2 ({ commit,state }) {
    const _users = (await firebase.database().ref(`/users`).once('value')).val();
    const users = [];
    for(const x in _users){
      users[_users[x].userId] = _users[x];
    }
    let deposits = (state.deposit.length>0)?state.deposit:[];
    firebase.firestore().collection("history").where("type", "==", "ฝาก").orderBy('createdate','desc').get().then((snapshot) => {
        snapshot.forEach((change) => {
            const deposit = change.data();
            if(users[deposit.userId]){
              const user = users[deposit.userId];
              deposit.key = change.id;
              deposit.linename = user.linename;
              deposit.firstname = user.firstname;
              deposit.lastname = user.lastname;
              deposit.bank = user.bank;
              deposit.account_no = user.account_no;
              deposit.code = user.code;
              deposit.pictureUrl = user.pictureUrl;
              deposits.push(deposit);
            }
        });
        deposits = _.orderBy(deposits, ['createdate'],['desc']);
        commit('SET_DEPOSIT', deposits);
    });
    //commit('SET_USERS', []);
  },
  async fetchWithdraw ({ commit,state }) {
    const _users = (await firebase.database().ref(`/users`).once('value')).val();
    const users = [];
    for(const x in _users){
      users[_users[x].userId] = _users[x];
    }
    let withdraws = (state.withdraw.length>0)?state.withdraw:[];
    firebase.firestore().collection("history").where("type", "==", "ถอน").orderBy('createdate','desc')
    .onSnapshot((snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            const withdraw = change.doc.data();
            if(users[withdraw.userId]){
              const user = users[withdraw.userId];
              withdraw.key = change.doc.id;
              withdraw.linename = user.linename;
              withdraw.firstname = user.firstname;
              withdraw.lastname = user.lastname;
              withdraw.bank = user.bank;
              withdraw.account_no = user.account_no;
              withdraw.code = user.code;
              withdraw.pictureUrl = user.pictureUrl;
              withdraws.push(withdraw);
            }
          }
          if (change.type === "modified") {
              const value = change.doc.data();
              const keyUser = _.findKey(withdraws, function(o) { return o.key === change.doc.id; });
              if(keyUser){
                const withdraw =  withdraws[keyUser];
                withdraw.qty = value.qty;
                withdraw.status = value.status;
                withdraw.updatetime = moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss");
                withdraws.splice(keyUser, 1);
                withdraw.key = change.doc.id;
                withdraws.splice(keyUser, 0, withdraw);
              }
          }
        });
        if(withdraws.length > 0){
          withdraws = _.orderBy(withdraws, ['createdate'],['desc']);
          commit('SET_WITHDRAW', withdraws);
        }
    });
  },
  /*updateUsers({state,commit}, {key,value}){
    console.log(key);
    console.log(value);
    console.log(state.users);
    const users = state.users;
    const keyUser = _.findKey(users, function(o) { return o.key === key; });
    if(keyUser){
      users.splice(keyUser, 1);
      value.key = key;
      users.splice(keyUser, 0, value);
      commit('SET_USERS', users);
    }
  },*/
}
